var _defs, _circle, _circle2, _circle3, _path, _circle4, _circle5, _circle6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "headsetGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(100, 150, 255, 1)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "rgba(150, 100, 255, 1)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(255, 100, 200, 1)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headsetGlow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    stroke: "url(#headsetGrad)",
    strokeWidth: 2.5,
    filter: "url(#headsetGlow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 14,
    stroke: "url(#headsetGrad)",
    strokeWidth: 2.5,
    filter: "url(#headsetGlow)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 5,
    fill: "url(#headsetGrad)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8V18M32 46V56M8 32H18M46 32H56",
    stroke: "url(#headsetGrad)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    filter: "url(#headsetGlow)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 20,
    r: 2,
    fill: "url(#headsetGrad)",
    opacity: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 44,
    r: 2,
    fill: "url(#headsetGrad)",
    opacity: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 32,
    r: 2,
    fill: "url(#headsetGrad)",
    opacity: 0.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 32,
    r: 2,
    fill: "url(#headsetGrad)",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadset);
export default __webpack_public_path__ + "static/media/headset.281fecafac2cfb24c65ee74bb9473b9a.svg";
export { ForwardRef as ReactComponent };